const proAdvantages = {
    en: [
        'With Swiset Pro you can have unlimited assets in your watchlist.',
        'With Swiset Pro you receive multiple insights of your trading activity.',
        'With Swiset Pro you can integrate unlimited broker accounts.',
        'With Swiset Pro you can import historic trades from several platforms.',
        'With Swiset Pro you can create a Trading Plan to enhance your discipline.',
        'With Swiset Pro you can create unlimited trading strategies to track them.',
    ],
    es: [
        'Con Swiset Pro podrás tener ilimitados activos en tu watchlist.',
        'Con Swiset Pro podrás recibir múltiples insights de tu actividad de trading.',
        'Con Swiset Pro podrás integrar ilimitadas cuentas de broker.',
        'Con Swiset Pro podrás importar trades históricos de diversas plataformas.',
        'Con Swiset Pro podrás crear Planes de Trading para mejorar tu disciplina.',
        'Con Swiset Pro podrás crear ilimitadas estrategias de trading para llevar su trazabilidad.',
    ],
};

export default proAdvantages;
